export const getKaraokes = (state) => state.karaokes
export const getKaraoke = (state) => (id) => state.karaokes.data.find(karaoke => karaoke.id === id)
export const getKaraokeDiscJockeys = (state) => (id) => state.karaokeDiscJockeys[id] || []
export const getParticipators = (state) => state.participators